import React from 'react';
import { HifsQueryProvider } from './HifsQueryProvider';

export const HifsProviders = ({ children }: any) => {
	return <HifsQueryProvider>{children}</HifsQueryProvider>;
};
